module.exports = __webpack_public_path__ + "static/media/genji-logo-fit.9aa4e3f2.png";